import {
	SECTIONS,
	SECTION_SIZING,
} from "apps/discovery/util/consts";

// templates; used in the `getRowInfo` helper
import MultiPhoto from "apps/discovery/components/user/MultiPhoto";
import PhotoAndText from "apps/discovery/components/user/PhotoAndText";
import PhotoWithCaption from "apps/discovery/components/user/PhotoWithCaption";
import EssayWithUserRow from "apps/discovery/components/user/EssayWithUserRow";
import QuestionComment from "apps/discovery/components/user/QuestionComment";

import DefaultHeader from "apps/discovery/components/headers/DefaultHeader";
import InterestSearch from "apps/discovery/containers/headers/InterestSearch";
import ImportantQuestions from "apps/discovery/containers/headers/ImportantQuestions";


export const getProfileUrl = ({ user, sectionId }) => {
	if (!user.username) {
		return "#";
	}

	let res = `/profile/${user.username}`;

	if (sectionId) {
		res = `${res}?cf=discovery_${sectionId}`;
	}

	return res;
};

export const getRowInfo = (sectionId) => {
	let Header;
	let Template;
	let templateName;
	let sizing;

	const blankRowProps = {
		color: "gray",
		sectionId,
	};

	switch (sectionId) {
		case SECTIONS.interests: {
			Header = InterestSearch;
			Template = PhotoAndText;

			templateName = "photoAndText";
			sizing = SECTION_SIZING.photoAndText;
			blankRowProps.color = "blue";

			break;
		}

		case SECTIONS.snapshots: {
			Header = DefaultHeader;
			Template = PhotoWithCaption;

			templateName = "photoWithCaption";
			sizing = SECTION_SIZING.photoWithCaption;

			break;
		}

		case SECTIONS.nearby: {
			Header = DefaultHeader;
			Template = PhotoAndText;

			templateName = "photoAndText";
			sizing = SECTION_SIZING.photoAndText;

			break;
		}

		case SECTIONS.question_comments: {
			Header = DefaultHeader;
			Template = QuestionComment;

			templateName = "questionComment";
			sizing = SECTION_SIZING.questionComment;

			break;
		}

		case SECTIONS.instagram: {
			Header = DefaultHeader;
			Template = MultiPhoto;

			templateName = "multiPhoto";
			sizing = SECTION_SIZING.multiPhoto;

			break;
		}

		case SECTIONS.passions: {
			Header = DefaultHeader;
			Template = EssayWithUserRow;

			templateName = "essayWithUserRow";
			sizing = SECTION_SIZING.essayWithUserRow;

			break;
		}

		case SECTIONS.important_questions: {
			Header = ImportantQuestions;
			Template = PhotoAndText;

			templateName = "photoAndText";
			sizing = SECTION_SIZING.photoAndText;

			break;
		}

		default: {
			Header = DefaultHeader;
			Template = PhotoAndText;

			templateName = "photoAndText";
			sizing = SECTION_SIZING.photoAndText;

			break;
		}
	}

	return {
		Header,
		Template,
		templateName,
		sizing,
		blankRowProps,
	};
};



// WEBPACK FOOTER //
// ./src/apps/discovery/util/helpers.js